class FJAddToCart {
  constructor() {
    // Shopify's own locale/market-aware root ("/" or e.g. "/fr-ca/"),
    // injected by Shopify on every storefront page — read, not created.
    this.routesRoot = window.Shopify?.routes?.root || '/';
    document.addEventListener('click', this.onClick.bind(this));
  }

  onClick(event) {
    const button = event.target.closest('[data-add-to-cart]');
    if (!button) return;
    this.addToCart(button);
  }

  async addToCart(button) {
    const variantId = button.dataset.variantId;
    if (!variantId) return;

    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding...';

    try {
      const response = await fetch(`${this.routesRoot}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });

      if (!response.ok) {
        // Shopify returns 422 with a readable reason (e.g. sold out).
        const error = await response.json().catch(() => ({}));
        this.showButtonMessage(button, originalText, error.description ? 'Unavailable' : "Couldn't add");
        return;
      }

      const cart = await fetch(`${this.routesRoot}cart.js`).then((res) => res.json());

      const cartUpdateEvent = new CustomEvent('fj:cart:updated', {
        bubbles: true,
        detail: { itemCount: cart.item_count, totalPrice: cart.total_price },
      });
      button.dispatchEvent(cartUpdateEvent);

      this.showButtonMessage(button, originalText, 'Added!');
    } catch (e) {
      console.error('Failed to add to cart:', e);
      this.showButtonMessage(button, originalText, "Couldn't add");
    }
  }

  // Briefly shows feedback on the button itself, then restores it.
  showButtonMessage(button, originalText, message) {
    button.textContent = message;
    setTimeout(() => {
      button.textContent = originalText;
      button.disabled = false;
    }, 1500);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new FJAddToCart();
});